import {
    CommitmentEntity,
    InteractionEntity,
    NoteEntity,
} from '../../coaching-base/config';
import {
    CoachingEventStatus,
    CommitmentApprovalDto,
    CommitmentDraftDto,
    CommitmentDto,
    CommitmentEvent,
    EventParticipantDto,
    FocusDto,
    NoteAndCommentary,
    ObservationSummaryDto,
} from '../../coaching-base/general';
import { BehaviourItem } from '../../coaching-tags/models/behaviour.coaching.model';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { SubBehaviourItem } from '../../coaching-tags/models/subbehaviour.coaching.model';
import { GoalCommitmentState } from '../commitment-goals/goals.commitment.state';
import { GoalsCollection } from '../goals-collection.model';

import { ApprovalAlertInfoView } from './approval-alert-info-view.model';
import { CloseContext } from './close-context.model';
import { DiffItemsInfoView } from './diff-items-info-view.model';
import { MirrorCopyAlertInfoView } from './mirror-copy-alert-info-view.model';

export interface TagInfo {
    behaviour?: BehaviourItem;
    subBehaviour?: SubBehaviourItem;
    focus?: FocusDto;
}

export interface AllowedActions {
    publish?: boolean;
    save?: boolean;
    close?: boolean;
    delete?: boolean;
    edit?: boolean;
}

export interface EnabledActions {
    publish?: boolean;
    save?: boolean;
    close?: boolean;
    delete?: boolean;
    edit?: boolean;
    teamsCallCanStartCall?: boolean;
    teamsCallHasChat?: boolean;
    teamsCallCanStartChat?: boolean;
}

export interface RootState {
    pending: {
        reload?: boolean;
        approval?: boolean;
        // approve?: boolean;
        // dispute?: boolean;
        // publish?: boolean;
        save?: boolean;
        // close?: boolean;
        notification?: boolean;
        delete?: boolean;
    };
    justSaved?: boolean; // TODO something more elaborate

    // lookups
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    metrics?: MetricItem[];

    // config
    coachingEvent?: CommitmentEntity;
    noteEntity?: NoteEntity;
    interactionEntity?: InteractionEntity;

    // main
    draftId?: string;
    diffItemsInfo?: DiffItemsInfoView;
    draft?: CommitmentDraftDto;
    approval?: CommitmentApprovalDto;
    approvalAlertInfo?: ApprovalAlertInfoView;
    commitment?: CommitmentDto;
    event?: CommitmentEvent;
    performer?: EventParticipantDto;
    coach?: EventParticipantDto;
    creatorName?: string;
    tagInfo?: TagInfo;
    statusName?: string;
    subStatusName?: string;
    subStatusMessage?: string;
    activeDays?: number;
    totalTimeStr?: string;
    mirrorCopyAlertInfo?: MirrorCopyAlertInfoView;

    //
    comments?: NoteAndCommentary[];
    linkedObservations?: ObservationSummaryDto[];
    preSelectedObservations?: ObservationSummaryDto[];
    lastLinkedObservations?: Map<
        number /* observationId */,
        ObservationSummaryDto
    >; // support multiple just in case

    //
    closingCtx?: CloseContext;
    signingOffCtx?: CoachingEventStatus;

    enabledActions?: EnabledActions;

    // modals
    isPublishing?: boolean;
    isClosingReason?: boolean;
    isClosing?: boolean;
    isDisputing?: boolean;
    isSigningOff?: boolean;

    goalsCollection?: GoalsCollection;

    // child states. to be used only by child reducers
    // TODO FIXME stop defining child state
    goalCommitment?: GoalCommitmentState;

    /** this contains if the user intended/wants to edit the form. i.e. toggled the edit button */
    editingIntended?: boolean;

    /** this controls if the user is actually allowed to edit the form */
    isEditing?: boolean;

    isReadOnly?: boolean;
    isReadWrite?: boolean;
}

export const defaultState = (): RootState => ({
    pending: {},
});
